import {
  GET_LELO_DATA,
  SUBMIT_DATA,
  LEVEL_UP,
  LEVEL_DOWN,
  SET_PASS,
  GET_AGE,
  ON_FORM_DATA_CHANGE,
  GET_LELO_COURSES,
  GET_LELO_COURSES_CHARTERID,
  GET_LELO_DATA_UUID,
  GET_LELO_COURSES_PERMALINK,
  GET_LELO_SESSION,
  GET_LELO_SESSION1,
} from "../types";

const LeloReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case LEVEL_UP:
      return {
        ...state,
        formLevel: state.formLevel >= 7 ? 7 : state.formLevel + 1,
      };

    case ON_FORM_DATA_CHANGE:
      return {
        ...state,
        formData: {
          ...state.formData,
          [payload.name]: payload.value,
        },
      };
    case LEVEL_DOWN:
      return {
        ...state,
        formLevel: state.formLevel <= 0 ? 0 : state.formLevel - 1,
      };
    case GET_AGE:
      return {
        ...state,
        age: payload,
      };
    case SET_PASS:
      return {
        ...state,
        pass: { ...state.pass, [payload.name]: payload.value },
      };
    case GET_LELO_DATA:
      return {
        ...state,
        leloData: payload,
        loading: false,
        error: null,
      };

    case GET_LELO_SESSION:
      return {
        ...state,
        leloSession: payload,
        loading: false,
        error: null,
      };
    case GET_LELO_SESSION1:
      return {
        ...state,
        leloSession1: payload,
        loading: false,
        error: null,
      };

    case GET_LELO_DATA_UUID:
      return {
        ...state,
        leloDatauuid: payload,
        loading: false,
        error: null,
      };
    case GET_LELO_COURSES_PERMALINK:
      return {
        ...state,
        leloDatapermalink: payload,
        loading: false,
        error: null,
      };

    case GET_LELO_COURSES:
      return {
        ...state,
        leloCourse: payload,
        loading: false,
        error: null,
      };

    case GET_LELO_COURSES_CHARTERID:
      return {
        ...state,
        leloCoursecarterid: payload,
        loading: false,
        error: null,
      };

    case SUBMIT_DATA:
      return {
        ...state,
        formData: payload,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default LeloReducer;
